<template>
    <el-container class='min-app' ref='homeGlobal'>
        <Aside :isUnfold='isUnfold' v-if='!isIframe' />
        <el-container direction='vertical'>
            <el-header height='50px' v-if='!isIframe'>
                <TagsView @testClick='testClick' :isUnfold='isUnfold' :isShowInfo='isShowInfo' :hasUploadList='true' />
            </el-header>
            <el-main :class="isIframe ? 'mail-panel-iframe':'mail-panel'">
                <keep-alive :include='cachedViews'>
                    <router-view></router-view>
                </keep-alive>
            </el-main>
            <intime-evaluate-plus class='eval_container_pp' ref='evaluateRef' :env='evaluateUserConfig.env' :lang='lang' :userInfo='evaluateUserConfig.userInfo'
                :templeteInfo='evaluateUserConfig.templeteInfo' />
            <FeedBack ref='feedbackRef' :env='combineComponentConfig.env' :lang='combineComponentConfig.lang' :userInfo='combineComponentConfig.userInfo'
                :componentBottom='combineComponentConfig.componentBottom' :intimeevaluateUserInfo='combineComponentConfig.intimeevaluateUserInfo'
                :intimeevaluateTempleteInfo='combineComponentConfig.intimeevaluateTempleteInfo' :tabs='combineComponentConfig.tabs'
                :whetherTheCoexistence='combineComponentConfig.whetherTheCoexistence' :themeColor='combineComponentConfig.themeColor' :tabsBackgroundColor='combineComponentConfig.tabsBackgroundColor'
                :unfoldColor='combineComponentConfig.unfoldColor' :configInfo='combineComponentConfig.configInfo' :helpInfo="{ ...combineComponentConfig.helpInfo }" />
        </el-container>
    </el-container>
</template>
<script>
import TagsView from '@/components/lots/themes/tags_nav/index.vue';
import Aside from '@/components/lots/themes/aside/Aside';
import { mapGetters } from 'vuex';
import utils from '@/utils/common.js';
import { evaluateConfig } from '../utils/evaluateConfig';
import config from '@/config/user.env.js';
import { setCombineComponentConfig } from '@/modules/sn/config/index.js';
import FeedBack from 'itsm-feedback-v2';
import Vue from 'vue';
import { IntimeEvaluatePlus } from 'intimeevaluateplus';
import { getDictionaryDetail } from '@/modules/sn/api/systemManagementApi.js';
const getIframeUrl = () => {
    let url = null;
    if (parent !== window) {
        try {
            url = parent.location.url;
        } catch (e) {
            url = document.referrer;
        }
    }

    return url;
};
export default {
    components: {
        TagsView,
        Aside,
        FeedBack,
        IntimeEvaluatePlus
    },
    data() {
        return {
            lang: 'zh-CN', // ja-JP  en-US zh-CN
            isUnfold: true,
            isShowInfo: true,
            evaluateConfig: evaluateConfig,
            isIframe: false
        };
    },
   async mounted() {
        Vue.prototype.$evaluateRef = this.$refs.evaluateRef;
        /**
         * 全局初始化 home ref
         */
        Vue.prototype.$homeRef = this.$refs.homeGlobal;
        Vue.prototype.$homeRef.setGlobalEvaluateConfig =
            this.setGlobalEvaluateConfig;
        await this.IframeFunc();
        const environment = utils.getEnvironmentTitle();
        document.title = `SNP ${environment}`;
    },
    computed: {
        ...mapGetters(['currentTenant', 'user']),
        cachedViews() {
            return this.$store.state.cachedViews;
        },
        key() {
            return this.$route.fullPath;
        },
        evaluateUserConfig() {
            return this.updateEvaluateConfig();
        },
        combineComponentConfig() {
            return this.updateComponentInfo();
        }
    },
    methods: {
        async IframeFunc() {
            if (window.frames.length !== parent.frames.length) {
                this.isIframe = true;
                const hrefMenuName = await this.getParentIFrameMenu(getIframeUrl());
                if (hrefMenuName !== '' && hrefMenuName !== undefined) {
                    window.location.href = hrefMenuName;
                } else {
                    window.location.href = '/sn.html#/sellInData';
                }
            }
        },
        async getParentIFrameMenu(url) {
            const menus = await this.checkIframeMenu(url) || [];
            let menuName = '';
            if (menus.length > 0) {
                menuName = menus[0].name;
            }
            return menuName;
        },
        async checkIframeMenu(url) {
            const params = {
                dictCode: 'IFRAMEDIC',
                pageNo: 1,
                pageSize: 1000
            };
            const res = await getDictionaryDetail(params);
            let filterMenu = [];
            if (res.code === '0') {
                const menus = res.data.list.filter((item) => {
                    return item.enableFlag === 1;
                });
                filterMenu = menus.filter((item) => {
                    return url.indexOf(item.code) > -1;
                });
            }
            return filterMenu;
        },
        setGlobalEvaluateConfig(scene = '触发式') {
            this.evaluateConfig.templeteInfo.scene = scene;
            this.$evaluateRef.openEvaluateModal();
        },
        updateEvaluateConfig() {
            const { userCode, userName } = this.user;
            this.evaluateConfig.userInfo.user_name = userName;
            this.evaluateConfig.userInfo.user_id = userCode;
            this.evaluateConfig.env = config.robotEnvironment;
            return this.evaluateConfig;
        },
        updateComponentInfo() {
            const { userCode, userName } = this.user;
            const env = config.robotEnvironment;
            const commonFieldList = [
                { name: '操作页面或菜单路径', value: window.location.href }
            ];
            return setCombineComponentConfig({
                userCode,
                userName,
                env,
                commonFieldList
            });
        },
        testClick() {
            if (window._paq) {
                if (this.isUnfold) {
                    window._paq.push([
                        'trackEvent',
                        'Menu',
                        'Click',
                        '取消固定菜单'
                    ]);
                } else {
                    window._paq.push([
                        'trackEvent',
                        'Menu',
                        'Click',
                        '固定菜单'
                    ]);
                }
            }
            this.isUnfold = !this.isUnfold;
        }
    },
    watch: {
        $route(val) {
            this.updateComponentInfo();
        }
    }
};
</script>
<style lang='less'>
// .eval_container_pp {
//     margin-top: 50px;
// }
@import '../styles/common.less';
.mail-panel-iframe{
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
</style>
